define([
	"dojo/_base/declare",
	"csi/def",
	"csi/html",
	"csi/locale",
	"csi/resolver",
	"csi/util"
], function(declare,csi_def,html,locale,resolver,util) {

	return declare(null, {
		m_name: null, 		// name of attribute
		m_prop: null, 		// node property to localize
		m_id: null, 		// attribute id used to look up name
		m_path: null, 		// path to attribute from current context
		m_class: null, 		// CSS class to use on element

		constructor: function(def) {
			this.m_id = util.getProperty(def, 'Id');
			this.m_prop = util.getProperty(def, 'Property');
			this.m_path = util.getProperty(def, 'Path');
			this.m_class = util.getProperty(def, 'Class');
			this.m_separator = util.getProperty(def, 'Separator', ':');
		},

		isLabel: function() {
			return true;
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			// summary: resolve name of label
			if (this.m_id) {
				rcRoot = resolver.resolveClass(rcRoot, nodeRoot, null, this.m_path);
			}
			
			this.m_name = lr.resolveHeadingNames(this.key, rcRoot ? rcRoot.getType() : null, this.m_id, this.m_prop, null).name;
		},

		keyToHtml: function(/*Context*/ctx, /*DOMNode*/refNode) {
			csi_def.processClass(this, refNode);
			html.setInnerText(refNode, this.m_name + (this.m_separator || ""));
		}
	});
});